import { LayoutDashboard, Database, Brain } from 'lucide-react';

const PILLARS = [
  {
    slug: 'bi-dashboards',
    color: 'blue',
    Icon: LayoutDashboard,
    title: 'BI & Dashboards',
    text: 'Executive dashboards and automated reporting in Tableau and Power BI. One trusted, real-time view of performance, built for the people making the decisions.',
    short: 'BI & Dashboards',
    href: '/services/bi-dashboards',
  },
  {
    slug: 'data-strategy',
    color: 'orange',
    Icon: Database,
    title: 'Data Strategy',
    text: 'Roadmaps, metric governance, and integration that turn disconnected systems into one reliable foundation you can build on.',
    short: 'Data Strategy',
    href: '/services/data-strategy',
  },
  {
    slug: 'advanced-analytics',
    color: 'purple',
    Icon: Brain,
    title: 'Advanced Analytics',
    text: 'Forecasting, segmentation, and predictive models that help you act on what\u2019s coming, not just report what already happened.',
    short: 'Advanced Analytics',
    cta: 'Advanced analytics services',
    href: '/services/advanced-analytics',
  },
];

export const ServicesPillars = () => (
  <section className="section services" id="services">
    <div className="container">
      <div className="heading">
        <p className="eyebrow" style={{ color: '#002A52' }}>What we do</p>
        <h2>Three ways we turn data into decisions.</h2>
        <p>We build your dashboards, plan your data, and predict what&rsquo;s coming next. Done deeply, not spread thin.</p>
      </div>

      <div className="cards pillars">
        {PILLARS.map((p) => (
          <article className="service" key={p.slug} data-testid={`service-pillar-${p.slug}`}>
            <div className={`icon ${p.color}`}><p.Icon className="w-6 h-6" /></div>
            <h3>{p.title}</h3>
            <p>{p.text}</p>
            <a className="text-link" href={p.href} data-testid={`service-pillar-link-${p.slug}`}>
              {p.cta ? p.cta : `Explore ${p.short}`} &rarr;
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);
